import instance from 'utils/apiCalls';
import { LoginFormI, MicrosoftLoginI } from '../../../types/interface';
import { AUTH_URLS } from './authUrls';

export const login = (data: LoginFormI) => async () => {
  const response = await instance.post(AUTH_URLS.LOGIN, data);
  return response;
};

export const loginWithMicrosoft = (data: MicrosoftLoginI) => async () => {
  const response = await instance.post(AUTH_URLS.LOGIN_WITH_MICROSOFT, data);
  return response;
};
